import { environment } from '@env';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { Clipboard } from '@angular/cdk/clipboard';
import { SharedModule } from '@shared/shared.module';
import { PromoBannerDTO } from '@shared/types/dtos/promo-banner-dto.type';
import { encodeStaticUrlPath } from '@shared/utils/http.utils';
import { InAppBrowserService } from '@core/services/in-app-browser/in-app-browser.service';

@Component({
    selector: 'app-promo-banner',
    templateUrl: './promo-banner.component.html',
    styleUrls: ['./promo-banner.component.scss'],
    imports: [
        CommonModule,
        SharedModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        ClipboardModule
    ]
})
export class PromoBannerComponent implements OnInit {
  @Input() banner!: PromoBannerDTO;

  @Output() clickBannerAction = new EventEmitter<number>();
  @Output() closeBanner = new EventEmitter<number>();
  @Output() doNotShowBanner = new EventEmitter<number>();

  protected promoCodeFormControl = new FormControl('');

  private baseURL = environment.baseURL;

  constructor(private clipboard: Clipboard, private inAppBrowser: InAppBrowserService) {}

  ngOnInit() {
    if (this.banner.promoCode) {
      this.promoCodeFormControl.setValue(this.banner.promoCode);
      this.promoCodeFormControl.disable();
    }
  }

  onCopyPromoCode() {
    this.clipboard.copy(this.banner.promoCode ?? '');
  }

  onCloseBanner() {
    this.closeBanner.emit(this.banner.id);
  }

  onDoNotShowAgain() {
    this.doNotShowBanner.emit(this.banner.id);
  }

  onOpenActionUrl() {
    if (this.banner.action.url) {
      this.clickBannerAction.emit(this.banner.id);
      this.inAppBrowser.open(this.banner.action.url);
    }
  }

  getUrl(url: string | null) {
    if (!url) return '';

    return url.startsWith('http') ? url : this.baseURL + encodeStaticUrlPath(url);
  }
}
